import type { Component } from "vue-utils"
import { createStateLoading } from "vue-utils"
import { Error } from "./Error"
import LoadingSpinner from "./LoadingSpinner"

const StateLoading = createStateLoading({
	LoadingComponent: LoadingSpinner as Component,
	ErrorComponent: Error,
})

export default StateLoading
